import Axios from 'axios'
import { createReducer } from 'typesafe-actions'
import { authAsync, logout } from './sagas'

export interface AuthReducerState {
    access_token: string
    loading: boolean
}

const access_token = localStorage.getItem('access_token') || ''

if (access_token) {
    Axios.defaults.headers.common.Authorization = `Bearer ${access_token}`
}

const initialState: AuthReducerState = {
    loading: false,
    access_token: localStorage.getItem('access_token') || '',
}

export const authReducer = createReducer<AuthReducerState>({
    ...initialState,
})
    .handleAction(authAsync, (state: AuthReducerState, action: any): AuthReducerState => {
        const { access_token } = action.payload
        localStorage.setItem('access_token', access_token)
        Axios.defaults.headers.common.Authorization = `Bearer ${access_token}`
        return {
            access_token,
            loading: false,
        }
    })
    .handleAction(logout, (state: AuthReducerState, action: any): AuthReducerState => {
        localStorage.removeItem('access_token')
        Axios.defaults.headers.common.Authorization = ''
        return {
            ...initialState,
        }
    })
